export const CN = 'PRELOADER_CN'
export const WIDTH = 'PRELOADER_WIDTH'
export const DISPLAY = 'PRELOADER_DISPLAY'
